function generateCloudinaryDailyKey() {
  const d = new Date();
  const mm = (d.getMonth() + 101).toString().slice(-2);
  const dd = (d.getDate() + 100).toString().slice(-2);
  return 'v' + d.getFullYear() + mm + dd;
}

export const CLOUDINARY_DAILY_KEY = generateCloudinaryDailyKey();
